/**
 * sk-extra-selector
 * used to create the extra configuration widget
 */
bookingApp.directive('skExtraSelector', function(){
    return {
        scope: {
            pricingFunc: '=',
            maxAdults: '=?',
            maxChildren: '=?',
            maxInfants: '=?',
            validForAdults: '=?',
            validForChildren: '=?',
            validForInfants: '=?',
            rooms: '=?',
            extra: '=?',
            safeApply: '=?',
            account: '=?',

            selectedAdults: '=?',
            selectedChildren: '=?',
            selectedInfants: '=?',
            selectedQuantity: '=?',
            selectedFrom: '=?',
            selectedTo: '=?',
            customFields: '=?',

            defaultDate: '=',
            showLevel: '=',
            startDate: '=?',
            endDate: '=?',
            isPaxable: '=',
            dateRangeType: '=',
            dateRangeRule: '=',
            chargeableTo: '=?',
            maxQuantity: '=?',

            itemOnly: '=?',
            capturePaxDetails: '=?',
            datesEditable: '=?',
            validFromDate: '=?',
            timesEditable: '=?',
            validFromTime: '=?',
            validFromTimeMax: '=?',
            validityPeriod: '=?',
            loadPrevious: '=?',
            previousLabel: '@',
            loadPreviousExtraFunc: '=?',
            sessionId: '=?',
            showLoader: '=?',
            hideLoader: '=?',
            showError: '=?',
            logError: '=?',
            previouslyLoadedDetails: '=?',
            minAge: '=?',
            maxAge: '=?',
            ageAtDate: '=?',

            editingExtra: '=',
            editExtraFunc: '=?',
            removeExtraFunc: '=?',
            acceptFunc: '=', // what should be called when the user clicks the accept button
            populatePurchaser: '=',
            prePopulateLeadGuest: '=',

            labelAdults: '=',
            labelChildren: '=',
            labelInfants: '='
        },
        controller: function ($scope, $http) {
            function init() {
                if (!$scope.editingExtra && ($scope.extra.dateRangeType === 1 || $scope.extra.dateRangeType === 5)) {
                    $scope.selectedDates.from = moment($scope.startDate).add(1, 'Day').toDate();
                }
            }

            $scope.session = session;

            //$scope.inputDate = new Date();
            $scope.inputDate = {};
            $scope.selectedDates = {};
            $scope.selectedDates.from = {};
            $scope.selectedDates.to = {};
            $scope.isValid = true;

            $scope.selectedTimes = {};
            $scope.selectedTimes.from = {};
            $scope.selectedTimes.to = {};

            $scope.maxDOB = moment().subtract(1, 'year');
            $scope.minDOB = moment().subtract(100, 'years');

            var minComparisonDate = moment();
            var maxComparisonDate = moment();

            if ($scope.ageAtDate) {
                minComparisonDate = moment($scope.ageAtDate);
                maxComparisonDate = moment($scope.ageAtDate);
            }

            $scope.maxAgeDOB = $scope.minAge ? maxComparisonDate.subtract($scope.minAge, 'years') : moment().subtract(1, 'year');
            $scope.minAgeDOB = $scope.maxAge ? minComparisonDate.subtract($scope.maxAge, 'years') : moment().subtract(100, 'years');
            $scope.minAgeDOB = $scope.minAgeDOB.format('YYYY-MM-DD');
            $scope.maxAgeDOB = $scope.maxAgeDOB.format('YYYY-MM-DD');

            $scope.showPreviousForm = false;
            $scope.previousExtraDetails = {extraNumber: '', extraLastName: ''};
            $scope.existingResId = null;
            // check if we should be loading previous extra details
            $scope.togglePreviousForm = function () {
                $scope.showPreviousForm = !$scope.showPreviousForm;
            };

            if ($scope.itemOnly) {
                $scope.bookingLevel = 'booking';
            } else {
                $scope.bookingLevel = $scope.rooms.length - 1;
            }
            $scope.maxPax = {adults: '', children: '', infants: ''};
            $scope.maxDates = {
                //min: moment($scope.startDate).format('YYYY-MM-DD'),
                minFrom: moment($scope.validFromDate || $scope.startDate).format('YYYY-MM-DD'),
                minTo: moment($scope.validFromDate || $scope.startDate).format('YYYY-MM-DD'),
                //max: ($scope.chargeableTo === 3) ? moment($scope.endDate).subtract(1,'day').endOf('day').format('YYYY-MM-DD') : moment($scope.endDate).endOf('day').format('YYYY-MM-DD') // set max value to end of the given day for max input date validation
                maxFrom: ($scope.chargeableTo === 3) ? moment($scope.endDate).subtract(1, 'day').endOf('day').format('YYYY-MM-DD') : moment($scope.endDate).endOf('day').format('YYYY-MM-DD'), // set max value to end of the given day for max input date validation
                maxTo: ($scope.chargeableTo === 3) ? moment($scope.endDate).subtract(1, 'day').endOf('day').format('YYYY-MM-DD') : moment($scope.endDate).endOf('day').format('YYYY-MM-DD'), // set max value to end of the given day for max input date validation
                min: moment($scope.validFromDate || $scope.startDate).format('YYYY-MM-DD'),
                max: moment($scope.endDate).endOf('day').format('YYYY-MM-DD')
                //max: ($scope.chargeableTo === 3) ? moment($scope.endDate).subtract(1,'day').endOf('day').format('YYYY-MM-DD') : moment($scope.endDate).endOf('day').format('YYYY-MM-DD') // set max value to end of the given day for max input date validation
            };
            $scope.maxDates.fromMax = $scope.maxDates.max;
            $scope.maxDates.toMin = $scope.maxDates.min;

            if ($scope.dateRangeType === 1) {
                $scope.maxDates.min = moment($scope.maxDates.min).add(1, 'day').format('YYYY-MM-DD');
                //$scope.maxDates.max = moment($scope.maxDates.max).add(1,'day').format('YYYY-MM-DD');
            }

            $scope.paxConfig = {
                adults: 0,
                children: 0,
                infants: 0
            };

            $scope.paxDetails = {
                name: {first: '', last: ''},
                dob: moment().subtract(30, 'years').toDate(),
                gender: '',
            };
            $scope.paxDetails.dob = null;

            // get from and to date
            $scope.selectedDates.from = moment($scope.validFromDate || $scope.startDate || $scope.defaultDate).toDate();
            $scope.selectedDates.to = moment($scope.endDate || $scope.defaultDate).toDate();

            $scope.getArray = function (num) {
                if (typeof num === 'undefined') {
                    return Array(0);
                }
                num++;
                return Array(num);
            };

            $scope.quantity = 1;

            $scope.showDateRange = function () {
                if (parseInt($scope.dateRangeType) === 0) {
                    return false
                } else {
                    return true;
                }
            };

            $scope.calculateValidity = function () {
                if ($scope.itemOnly) {
                    var selectDateFrom = $scope.validFromDate || $scope.selectedDates.from;
                    // validity periods and times
                    $scope.validityDetails = validityPasser.getNextValidFromDateAndTime($scope.validityPeriod, selectDateFrom, $scope.validFromTime, $scope.validFromTimeMax, moment());

                    $scope.selectedTimes.to = moment($scope.validityDetails.maxTime, 'HH:mm:ss').format('HH:mm');
                    if ($scope.validFromDate) {
                        $scope.selectedDates.to = $scope.validityDetails.maxDate.toDate();
                    } else {
                        $scope.selectedDates.to = $scope.validityDetails.maxDate.toDate();
                    }
                    // get a list of valid from times for extra only bookings
                    if ($scope.validFromDate) {
                        $scope.validTimes = validityPasser.getValidFromTimes($scope.validityPeriod, moment($scope.validFromDate), $scope.validFromTime, $scope.validFromTimeMax, moment(), 15);
                        // reset to current time - season licences
                        $scope.validTimes.times = [moment($scope.validityDetails.minTime, 'HH:mm:ss').format('HH:mm')];
                        $scope.validTimes.startCurrentTime = $scope.validTimes.times[0];
                    } else {
                        var daysDiff = moment().diff($scope.selectedDates.from, 'days');

                        $scope.validTimes = validityPasser.getValidFromTimes($scope.validityPeriod, moment($scope.selectedDates.from), $scope.validFromTime, $scope.validFromTimeMax, moment($scope.selectedDates.from), 15);
                    }
                    if ((typeof $scope.previouslyLoadedDetails === 'undefined')) {
                        $scope.selectedTimes.from = $scope.validTimes.startCurrentTime;
                    } else {
                        if ($scope.validTimes.times.indexOf($scope.previouslyLoadedDetails.startTime) < 0) {
                            $scope.selectedTimes.from = $scope.validTimes.startCurrentTime;
                        }
                    }

                    $scope.maxDates.maxFrom = $scope.validityDetails.maxDate.toDate();
                    $scope.maxDates.maxTo = $scope.validityDetails.maxDate.toDate();
                    $scope.maxDates.max = $scope.maxDates.maxTo;
                    $scope.maxDates.minFromFormatted = $scope.validityDetails.minDate.format('YYYY-MM-DD');
                    $scope.maxDates.minFrom = $scope.validityDetails.minDate.toDate();
                    // if there is no validity periods data set then don't setup the max dates
                    if (!$scope.validFromDate) {
                        $scope.maxDates.maxFrom = '';
                        $scope.maxDates.minFrom = moment().hour(0).minute(0).second(0).millisecond(0).toDate();
                        $scope.maxDates.minFromFormatted = moment().hour(0).minute(0).second(0).millisecond(0).format('YYYY-MM-DD');
                        $scope.selectedTimes.to = $scope.selectedTimes.from;
                    }
                }
            };

            $scope.calculateValidity();

            // edit cart - update models with passed in data
            if (typeof $scope.previouslyLoadedDetails !== 'undefined') {
                // setup validity details
                $scope.selectedDates.from = $scope.previouslyLoadedDetails.extraStart;
                $scope.selectedDates.to = $scope.previouslyLoadedDetails.extraEnd;
                if ($scope.validFromDate) {
                    $scope.validTimes = validityPasser.getValidFromTimes($scope.validityPeriod, moment($scope.validFromDate), $scope.validFromTime, $scope.validFromTimeMax, moment(), 15);
                    // reset to current time - season licences
                    $scope.validTimes.times = [$scope.previouslyLoadedDetails.startTime];
                }
                $scope.selectedTimes.from = $scope.previouslyLoadedDetails.startTime;
                $scope.selectedTimes.to = $scope.previouslyLoadedDetails.endTime;
                // setup pax details
                $scope.paxDetails.name.first = $scope.previouslyLoadedDetails.paxDetails.name.first;
                $scope.paxDetails.name.last = $scope.previouslyLoadedDetails.paxDetails.name.last;
                $scope.paxDetails.dob = $scope.previouslyLoadedDetails.paxDetails.dob;
                $scope.paxDetails.gender = $scope.previouslyLoadedDetails.paxDetails.gender;
                $scope.customFields = $scope.previouslyLoadedDetails.customFields;
            }

            $scope.priceOb = {};


            $scope.recalculatePricing = function () {
                $scope.priceOb = $scope.pricingFunc(parseInt($scope.quantity), $scope.selectedDates.from, $scope.selectedDates.to, $scope.paxConfig.adults, $scope.paxConfig.children, $scope.paxConfig.infants, $scope.itemOnly);
            };

            $scope.addToCart = function (reloadExtra) {
                if (!$scope.validateExtraCustomFields()) {
                    $scope.extrasSelectorForm.$valid = false;
                }
                // check the form is valid if not make the form dirty
                if ($scope.extrasSelectorForm.$valid) {
                    if (isItemOnly) {
                        $scope.populatePurchaser($scope.paxDetails.name.first, $scope.paxDetails.name.last);
                    }
                    if (reloadExtra) {
                        $scope.acceptFunc(parseInt($scope.quantity), $scope.selectedDates.from, $scope.selectedDates.to, $scope.paxConfig.adults, $scope.paxConfig.children, $scope.paxConfig.infants, $scope.bookingLevel, $scope.paxDetails, $scope.existingResId, $scope.selectedTimes.from, $scope.selectedTimes.to, true, $scope.customFields);
                    } else {
                        $scope.acceptFunc(parseInt($scope.quantity), $scope.selectedDates.from, $scope.selectedDates.to, $scope.paxConfig.adults, $scope.paxConfig.children, $scope.paxConfig.infants, $scope.bookingLevel, $scope.paxDetails, $scope.existingResId, $scope.selectedTimes.from, $scope.selectedTimes.to, false, $scope.customFields);
                    }
                } else {
                    angular.forEach($scope.extrasSelectorForm, function (value, key) {
                        if (!value || value.$dirty === undefined) {
                            return;
                        } else {
                            value.$setDirty();
                        }
                    });
                    // scroll to the errors
                    $scope.scrollToError();
                }
            };

            $scope.scrollToError = function () {
                if (typeof $('.sk-input-group.has-error').position() !== 'undefined') {
                    if (typeof $('.sk-input-group.has-error').position().top !== 'undefined') {
                        var errorY = $('.sk-input-group.has-error').position().top;
                        $('html, body').stop().animate({scrollTop: (errorY - 50)});
                    }
                }
            };


            $scope.safeApply = function (fn) {
                var phase = this.$root.$$phase;
                if (phase == '$apply' || phase == '$digest') {
                    if (fn && (typeof (fn) === 'function')) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            $scope.updateExtra = function () {
                $scope.editExtraFunc($scope.selectedDates.from, $scope.selectedDates.to, $scope.paxConfig.adults, $scope.paxConfig.children, $scope.paxConfig.infants, $scope.quantity, $scope.selectedTimes.from, $scope.selectedTimes.to, $scope.paxDetails, $scope.itemOnly);
            };

            $scope.removeExtra = function () {
                $scope.removeExtraFunc();
            };

            $scope.validateExtraCustomFields = function () {
                var angularForm = $scope.extrasSelectorForm,
                    valid = true;

                // Validate custom field if there is one
                angular.forEach($scope.customFields, function (customField, index) {
                    var customFieldSubForm = angularForm['customField' + customField.id],
                        customFieldModel, value = null;
                    // Reset custom fields value
                    $scope.customFields[index].value = value;
                    if (customFieldSubForm !== undefined) {
                        customFieldModel = customFieldSubForm['customField' + customField.id];
                        customFieldSubForm.$setDirty(true);
                        if (customFieldModel !== undefined) {
                            customFieldModel.$setDirty(true);
                            value = customFieldModel.$viewValue;
                            if (value === undefined || value === null) {
                                value = '';
                            }
                            angular.forEach(customFieldModel.$parsers, function (parsers) {
                                parsers(value);
                            });
                            if (valid) {
                                valid = (customFieldModel.$invalid !== true);
                            }
                            customFieldModel.$render();
                            $scope.customFields[index].value = value;
                        }
                    }
                });
                return valid;
            };

            $scope.getMaxPax = function () {
                if (!$scope.maxQuantity) {
                    return '';
                }
                var maxPaxConfig = configurationChecker.generateMaxPaxConfigObject($scope.maxQuantity, $scope.maxQuantity, $scope.maxQuantity, $scope.maxQuantity, true, true, true);
                var incrementOb = configurationChecker.generateIncrementPaxObject($scope.paxConfig.adults, $scope.paxConfig.children, $scope.paxConfig.infants);
                // check for the values of the booking level
                var paxConfigured = configurationChecker.updateMaxPax(maxPaxConfig, incrementOb);
                $scope.maxPax.adults = paxConfigured.available.adults;
                $scope.maxPax.children = paxConfigured.available.children;
                $scope.maxPax.infants = paxConfigured.available.infants;
            };
            /**
             * setup values for editing extras
             */

            // setup selected date values
            if (typeof $scope.selectedFrom !== 'undefined') {
                $scope.selectedDates.from = moment($scope.selectedFrom).toDate();
            }
            if (typeof $scope.selectedTo !== 'undefined') {
                $scope.selectedDates.to = moment($scope.selectedTo).toDate();
            }

            // quantity
            if (typeof $scope.selectedQuantity !== 'undefined') {
                $scope.quantity = $scope.selectedQuantity;
            }

            // pax configurations
            if ($scope.isPaxable) {// check extra type takes pax as a value
                if (typeof $scope.selectedAdults !== 'undefined') {
                    $scope.paxConfig.adults = $scope.selectedAdults;
                    if (!$scope.validForAdults) {
                        $scope.paxConfig.adults = 0;
                    }
                }
                if (typeof $scope.selectedChildren !== 'undefined') {
                    $scope.paxConfig.children = $scope.selectedChildren;
                    if (!$scope.validForChildren) {
                        $scope.paxConfig.children = 0;
                    }
                }
                if (typeof $scope.selectedInfants !== 'undefined') {
                    $scope.paxConfig.infants = $scope.selectedInfants;
                    if (!$scope.validForInfants) {
                        $scope.paxConfig.infants = 0;
                    }
                }
            }


            $scope.getLevels = function () {
                var options = [];
                options.push({
                    label: 'Booking',
                    value: 'booking'
                });
                // loop through the rooms
                var roomCount = 0;
                for (var room in $scope.rooms) {
                    if ($scope.rooms.hasOwnProperty(room) && $scope.rooms[room].showPaxGrouped) {
                        var selectedRoom = $scope.rooms[room];
                        options.push({
                            label: selectedRoom.roomDetails.bookable.marketingName,
                            value: roomCount
                        });
                    }
                    roomCount++;
                }
                return options;
            };

            $scope.loadPreviousExtra = function () {
                // send ajax request to the server with the previous details, return the details and load them into the extras details
                // check that these both have values otherwise show errors
                if ($scope.previousExtraForm.$valid) {
                    $scope.showLoader();
                    // send request to the server
                    $http.post('/front-booking/get-previous-permit', {
                        permitNo: $scope.previousExtraDetails.extraNumber,
                        lastName: $scope.previousExtraDetails.extraLastName,
                        sid: $scope.sessionId,
                        format: 'json'
                    })
                        .success(function (data, status, headers, config) {
                            //$scope.session.isLoading = false;
                            if (!Array.isArray(data.formLevel)) {
                                // set the values of the fields in here
                                $scope.paxDetails.name.first = data.formLevel.firstName;
                                $scope.paxDetails.name.last = data.formLevel.lastName;
                                $scope.existingResId = data.formLevel.existingResId;
                                $scope.paxDetails.gender = data.formLevel.gender.replace(/\w\S*/g, function (txt) {
                                    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                                });
                                $scope.paxDetails.dob = moment(data.formLevel.dateOfBirth).toDate();
                                $scope.populatePurchaser($scope.paxDetails.name.first, $scope.paxDetails.name.last);
                                $scope.prePopulateLeadGuest(
                                    typeof data.formLevel.leadGuestTitle !== 'undefined' ? data.formLevel.leadGuestTitle : '',
                                    typeof data.formLevel.leadGuestFirstName !== 'undefined' ? data.formLevel.leadGuestFirstName : '',
                                    typeof data.formLevel.leadGuestLastName !== 'undefined' ? data.formLevel.leadGuestLastName : '',
                                    typeof data.formLevel.leadGuestEmail !== 'undefined' ? data.formLevel.leadGuestEmail : '',
                                    typeof data.formLevel.leadGuestPhone !== 'undefined' ? data.formLevel.leadGuestPhone : '',
                                    typeof data.formLevel.leadGuestMobile !== 'undefined' ? data.formLevel.leadGuestMobile : '',
                                    typeof data.formLevel.leadGuestPostAddress !== 'undefined' ? data.formLevel.leadGuestPostAddress : '',
                                    typeof data.formLevel.leadGuestSuburb !== 'undefined' ? data.formLevel.leadGuestSuburb : '',
                                    typeof data.formLevel.leadGuestCity !== 'undefined' ? data.formLevel.leadGuestCity : '',
                                    typeof data.formLevel.leadGuestPostCode !== 'undefined' ? data.formLevel.leadGuestPostCode : '',
                                    typeof data.formLevel.leadGuestCountry !== 'undefined' ? data.formLevel.leadGuestCountry.id : ''
                                );
                                $scope.togglePreviousForm();
                            } else {
                                // user was not found
                                $scope.showError('Licence Not Found', 'Invalid licence number/last name entered');
                            }
                            $scope.hideLoader();
                        }).error(function (data, status, headers, config) {
                        // will need ot pass in the error logger and the show error methods.
                        $scope.logError('error retrieving previous extra', {status: status, headers: headers});
                        $scope.showError('Whoops', 'We were unable to retrieve a previous licence. Please try clearing your browser cache and refreshing', true);
                        $scope.hideLoader();
                    });
                }
            };

            $scope.levels = $scope.getLevels();
            /**
             * Watchers below, watching for changes on the selector will rerun the pricing calculation
             */

            // watch for changes in the pax selectors and update the max values accordingly
            $scope.$watch('paxConfig', function (newVal) {
                $scope.getMaxPax();
            }, true);


            // watch for changes in quantity and update the price
            $scope.$watch('quantity', function (newVal) {
                $scope.recalculatePricing();
            });

            $scope.$watch('bookingLevel', function (newVal) {

            });

            if (isItemOnly && !$scope.validFromDate) {
                // watch for changes to the valid from date and set the valid to date to be the same.
                $scope.$watch('selectedTimes', function (newVal, oldVal) {
                    $scope.selectedTimes.to = $scope.selectedTimes.from;
                }, true);
            }

            // watch for changes to the date models
            $scope.$watch('selectedDates', function (newVal) {
                if (isItemOnly) {
                    if (!$scope.validFromDate) {
                        if (typeof $scope.selectedDates.from === 'undefined' || $scope.selectedDates.from < moment($scope.maxDates.min).toDate()) {
                            // this will happen when setting the (from) date to the max date, as the date selector will use time stamping to decide if the date is before the max
                            $scope.selectedDates.from = moment($scope.maxDates.min).toDate();
                            $scope.safeApply();
                        } // -- default the from date back to todays date....
                        // recalculte the to date based on the from date.
                    }
                    $scope.calculateValidity();
                    $scope.showLoader();
                    // check the validity...
                    $http.post('/front-booking/api-check-extra-validity', {
                        isItemOnly: true,
                        sid: $scope.sessionId,
                        dateFrom: moment($scope.selectedDates.from).format('YYYY-MM-DD'),
                        dateTo: moment($scope.selectedDates.to).format('YYYY-MM-DD'),
                        extraId: $scope.extra.id,
                        categoryId: $scope.extra.category.id,
                        format: 'json'
                    }).success(function (data, status, headers, config) {
                        $scope.hideLoader();
                        $scope.isValid = data.isValid;
                        if (!data.isValid) {
                            // display an error and stop the feature from being added to the cart
                            $scope.showError('Unavailable', 'This is not available / valid with the values entered', true);
                        }
                    }).error(function (data, status, headers, config) {
                        $scope.hideLoader();
                    });

                } else {
                    // maxFrom and maxTo
                    if (typeof $scope.selectedDates.to === 'undefined') {
                        // this will happen when setting the (to) date to the max date, as the date selector will using time stamping to decide if the date is before the max
                        $scope.selectedDates.to = moment($scope.maxDates.maxTo).toDate();
                    }
                    if (typeof $scope.selectedDates.from === 'undefined') {
                        // this will happen when setting the (from) date to the max date, as the date selector will use time stamping to decide if the date is before the max
                        $scope.selectedDates.from = moment($scope.maxDates.maxFrom).toDate();
                    }
                    $scope.validTimes = validityPasser.getValidFromTimes($scope.validityPeriod, $scope.validFromDate, $scope.validFromTime, $scope.validFromTimeMax, moment($scope.selectedDates.from), 15);
                    $scope.selectedTimes.from = $scope.validTimes.startCurrentTime;
                }
                if (typeof $scope.selectedDates.from === 'undefined') {
                    // this will happen when setting the (from) date to the max date, as the date selector will use time stamping to decide if the date is before the max
                    $scope.selectedDates.from = moment($scope.maxDates.min).toDate();
                    $scope.safeApply();
                }
                // recalculate the maxFrom and minTo dates based on the new values...
                $scope.maxDates.fromMax = moment($scope.selectedDates.to).format('YYYY-MM-DD');
                if (isItemOnly) {
                    $scope.maxDates.fromMax = moment().add(1, 'year').format('YYYY-MM-DD');
                }
                $scope.maxDates.toMin = moment($scope.selectedDates.from).format('YYYY-MM-DD');


                // Don't allow same day booking if it not a daily or daily inclusive
                if ($scope.dateRangeType !== 1 && $scope.dateRangeType !== 5 && !$scope.validityPeriod) {
                    $scope.maxDates.toMin = moment($scope.selectedDates.from).add(1, 'day').format('YYYY-MM-DD');
                    $scope.maxDates.maxTo = moment($scope.maxDates.max).format('YYYY-MM-DD');
                    $scope.maxDates.fromMax = moment($scope.maxDates.max).subtract('1', 'day').format('YYYY-MM-DD');
                }

                if($scope.validityPeriod && $scope.validFromDate) {
                    $scope.maxDates.toMin = moment($scope.maxDates.minFrom).format('YYYY-MM-DD');
                }
                $scope.safeApply();
                $scope.recalculatePricing();
                $scope.safeApply();
            }, true);

            // watch for changes to the pax selectors
            $scope.$watch('paxConfig', function (newVal) {
                $scope.recalculatePricing();
            }, true);

            $scope.$watch('selectedDates.from', function (newVal) {
                var compareDate = newVal;

                if (moment($scope.ageAtDate).isValid()) {
                    compareDate = $scope.ageAtDate;
                }
                // if($scope.account !== 'docpermit') {
                // any changes to the date need to set offset the validation for any age requirements
                if ($scope.minAge) {
                    $scope.maxAgeDOB = moment(compareDate).subtract($scope.minAge, 'years').subtract(1, 'days').format('YYYY-MM-DD');
                }
                if ($scope.maxAge) {
                    $scope.minAgeDOB = moment(compareDate).subtract($scope.maxAge, 'years').format('YYYY-MM-DD');
                }
                // }
            });

            // prevent user from clearing the DOB field
            $scope.$watch('paxDetails.dob', function (newVal) {
                if (typeof $scope.extraDetails.paxDOB !== 'undefined') {
                    if (!newVal && (!$scope.extraDetails.paxDOB.$pristine) && (!$scope.extraDetails.paxDOB.$error.max) && (!$scope.extraDetails.paxDOB.$error.min)) {
                        $scope.paxDetails.dob = moment().subtract(30, 'years').toDate();
                    }
                }
            }, true);

            $scope.setToDefaultDOB = function () {
                if ($scope.paxDetails.dob === null) {
                    $scope.paxDetails.dob = moment().subtract(30, 'years').toDate();
                }
            };
            init();
        },
        template: '<div class="sk-extra-selector" ng-form name="extrasSelectorForm">' +
            '<form name="extraDetails" ng-hide="itemOnly && showPreviousForm">' +

                '<div class="row">' +
                    '<div class="room-or-booking container" ng-show="!editingExtra && showLevel">' +
                        '<div class="sk-input-group col-xs-12 inactive sk-selected" sk-select="static">' +
                            '<label>Add to...</label>' +
                            '<select ng-model="bookingLevel" ng-options="level.value as level.label for level in levels"></select>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="row">' +
                    '<div class="sk-room-pax container" ng-if="isPaxable">' +
                        '<div class="paxing-group">' +
                            '<div class="pax-selectors" ng-class="{\'all-pax-required\':(validForAdults && validForChildren && validForInfants), \'long-labels\':(labelAdults.length > 8 || labelChildren.length > 8 || labelInfants.length > 8)}">' +
                                '<div sk-number="static" class="sk-input-group col-xs-12 inactive adults" ng-show="validForAdults || (!validForAdults && !validForChildren && !validForInfants)">' +
                                    '<label ng-bind="labelAdults"></label>' +
                                    '<input type="number" ng-model="paxConfig.adults" max="{{maxPax.adults}}" min="0" />' +
                                '</div>' +
                                '<div sk-number="static" class="sk-input-group col-xs-12 inactive children" ng-show="validForChildren || (!validForAdults && !validForChildren && !validForInfants)">' +
                                    '<label ng-bind="labelChildren"></label>' +
                                    '<input type="number" ng-model="paxConfig.children" max="{{maxPax.children}}" min="0" />' +
                                '</div>' +
                                '<div sk-number="static" class="sk-input-group col-xs-12 inactive infants" ng-show="validForInfants || (!validForAdults && !validForChildren && !validForInfants)">' +
                                    '<label ng-bind="labelInfants"></label>' +
                                    '<input type="number" ng-model="paxConfig.infants" max="{{maxPax.infants}}" min="0" />' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="quantity form-group" ng-form name="quantityForm" ng-hide="isPaxable" ng-if="!itemOnly">' +
                    '<div class="sk-input-group col-xs-12 inactive sk-selected" sk-number="static">' +
                        '<label>Quantity</label>' +
                        '<input type="number" max="{{maxQuantity}}" ng-model="$parent.quantity" min="0" name="quantity"/>' +
                        '<div class="angular-form-error" ng-if="quantityForm.quantity.$invalid && quantityForm.quantity.$dirty">' +
                            '<label>Maximum of {{maxQuantity}} is allowed for this extra</label>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="date-from">' +
                    '<div class="sk-input-group col-xs-12 inactive sk-selected" sk-date="static" model="selectedDates.from" safe-apply="safeApply" ng-if="showDateRange() || (itemOnly)">' +
                        '<label>From</label>' +
                        '<input name="fromDate" class="from-date" type="date" ng-model="selectedDates.from" max="{{maxDates.fromMax}}" min="{{maxDates.min}}" ng-readonly="dateRangeRule === 1 || (itemOnly && !datesEditable)" ng-required="showDateRange()"/>' +
                        '<div class="angular-form-error" ng-if="extrasSelectorForm.extraDateFrom.$invalid && extrasSelectorForm.extraDateFrom.$dirty">' +
                            '<label>From date must be set</label>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="time-from" ng-if="itemOnly">' +
                    '<div class="sk-input-group col-xs-12 inactive sk-selected" sk-select="static">' +
                        '<label>Starting</label>' +
                        '<select ng-model="selectedTimes.from" ng-options="time for time in validTimes.times" ng-disabled="itemOnly && !timesEditable"></select>' +
                    '</div>' +
                '</div>' +

                '<div class="date-to">' +
                    '<div class="sk-input-group col-xs-12 inactive sk-selected" sk-date="static" model="selectedDates.to" safe-apply="safeApply" ng-if="showDateRange() || (itemOnly)">' +
                        '<label>To</label>' +
                        '<input type="date" ng-model="selectedDates.to" max="{{maxDates.max}}" min="{{maxDates.toMin}}" ng-readonly="dateRangeRule === 1 || (itemOnly)" ng-disabled="itemOnly" />' +
                        '<div class="angualr-form-error" ng-if="extrasSelectorForm.extraDateTo.$invalid && extrasSelectorForm.extraDateTo.$dirty">' +
                            '<label>To date must be set</label>' +
                        '</div>' +
                    '</div>' +
                '</div>' +

                '<div class="time-to" ng-if="itemOnly">' +
                    '<div class="sk-input-group col-xs-12 inactive sk-selected" sk-text="static">' +
                        '<label>Ending</label>' +
                        '<input type="text" ng-model="selectedTimes.to" ng-readonly="true" ng-disabled="itemOnly && !timesEditable">' +
                    '</div>' +
                '</div>' +

                '<div class="pax-details" ng-if="capturePaxDetails">' +
                    '<div class="sk-input-group col-xs-12 inactive" sk-text ng-class="{\'has-error\':extraDetails.paxFirstName.$invalid && extrasSelectorForm.$dirty, \'sk-selected\':paxDetails.name.first.length > 0}">' +
                        '<label>First Name*</label>' +
                        '<input name="paxFirstName" type="text" ng-model="paxDetails.name.first" ng-required="true">' +
                        '<div class="angular-form-error">' +
                            '<label>First name is required</label>' +
                        '</div>' +
                    '</div>' +
                    '<div class="sk-input-group col-xs-12 inactive" sk-text ng-class="{\'has-error\':extraDetails.paxLastName.$invalid && extrasSelectorForm.$dirty, \'sk-selected\':paxDetails.name.last.length > 0}">' +
                        '<label>Last Name*</label>' +
                        '<input name="paxLastName" type="text" ng-model="paxDetails.name.last" ng-required="true">' +
                        '<div class="angular-form-error">' +
                            '<label>Last name is required</label>' +
                        '</div>' +
                    '</div>' +
                    '<div ng-click="setToDefaultDOB()" class="sk-input-group col-xs-12 inactive" sk-date model="paxDetails.dob" safe-apply="safeApply" ng-class="{\'has-error\':extraDetails.paxDOB.$invalid && extrasSelectorForm.$dirty, \'sk-selected\':paxDetails.dob}">' +
                        '<label>Date Of Birth*</label>' +
                        '<input name="paxDOB" type="date" ng-model="paxDetails.dob" ng-required="true" min="{{minDOB.format(\'YYYY-MM-DD\')}}" max="{{maxDOB.format(\'YYYY-MM-DD\')}}" ng-min="minAgeDOB" ng-max="maxAgeDOB">' +
                        '<div class="angular-form-error">' +
                            '<label ng-if="!extraDetails.paxDOB.$error.min && !extraDetails.paxDOB.$error.max">Date of birth is required</label>' +
                            '<label ng-if="extraDetails.paxDOB.$error.max">Must be older than {{minAge}} to purchase</label>' +
                            '<label ng-if="extraDetails.paxDOB.$error.min">Must be younger than {{maxAge}} to purchase</label>' +
                        '</div>' +
                    '</div>' +
                    '<div class="sk-input-group col-xs-12 inactive" sk-select ng-class="{\'sk-selected\':paxDetails.gender.length > 0, \'has-error\':extraDetails.paxGender.$invalid && extrasSelectorForm.$dirty}">' +
                        '<label for="gender">Gender*</label>' +
                        '<select name="paxGender" id="gender" ng-model="paxDetails.gender" ng-required="true" ng-options="option as option for option in [\'Male\',\'Female\']" required>' +
                            '<option></option>' +
                        '</select>' +
                        '<div class="angular-form-error">' +
                            '<label>Gender is required</label>' +
                        '</div>' +
                    '</div>' +
                '</div>' +
            '</form>' +

            '<div class="custom-fields extra-custom-fields">' +
                '<sk-custom-field ng-repeat="(index, field) in customFields" name="customField{{field.id}}" attributes="field.attributes" errormessages="field.errorMessages" type="field.type" field="field" label="field.name" account="account" ng-model="customFields[index].value"></sk-custom-field>' +
            '</div>' +

            '<form name="previousExtraForm" class="previousExtraForm">' +
                '<div class="row">' +
                    '<div class="container-fluid load-previous" ng-if="itemOnly && loadPrevious">' +
                        '<button class="btn btn-primary col-xs-12" ng-click="togglePreviousForm()" ng-hide="showPreviousForm">Load previous <span ng-bind="previousLabel | lowercase"></span></button>' +
                        '<div class="sk-input-group col-xs-12 inactive" ng-class="{\'has-error\':previousExtraForm.previousExtraNumber.$invalid && previousExtraForm.$dirty}" sk-text ng-if="showPreviousForm">' +
                            '<label><span ng-bind="previousLabel"></span> Number</label>' +
                            '<input type="text" name="previousExtraNumber" ng-model="previousExtraDetails.extraNumber" id="previousExtraNumber" ng-required="true">' +
                            '<div class="angular-form-error">' +
                                '<label>' +
                                    '<span ng-bind="previousLabel"></span> Number required' +
                                '</label>' +
                            '</div>' +
                        '</div>' +
                        '<div class="sk-input-group col-xs-12 inactive" ng-class="{\'has-error\':previousExtraForm.previousExtraLastName.$invalid && previousExtraForm.$dirty}" sk-text ng-if="showPreviousForm">' +
                            '<label>Last Name</label>' +
                            '<input type="text" name="previousExtraLastName" ng-model="previousExtraDetails.extraLastName" id="previousExtraLastname" ng-required="true">' +
                            '<div class="angular-form-error">' +
                                '<label>' +
                                    'Last Name required' +
                                '</label>' +
                            '</div>' +
                        '</div>' +
                        '<button class="btn btn-primary col-xs-12 load-previous-extra" ng-click="loadPreviousExtra()" ng-show="showPreviousForm">Load Details</button>' +
                        '<button class="btn btn-primary col-xs-12" ng-click="togglePreviousForm()" ng-show="showPreviousForm">Cancel</button>' +
                    '</div>' +
                '</div>' +
            '</form>' +

            '<div class="price text-right" ng-if="isValid">' +
                '{{priceOb.totalPrice | convert | money:session.locals[session.selectedFilters.currency].currencySymbol:session.locals[session.selectedFilters.currency].thousandsSep:session.locals[session.selectedFilters.currency].decimalPoint}}' +
                '<div class="unit-price">{{priceOb.priceFrom | convert | money:session.locals[session.selectedFilters.currency].currencySymbol:session.locals[session.selectedFilters.currency].thousandsSep:session.locals[session.selectedFilters.currency].decimalPoint}} {{priceOb.priced}}</div>' +
            '</div>' +
            '<div class="text-center unavailable-text" ng-if="isValid === false"><h3>Unavailable</h3></div>' +
            '<div ng-hide="editingExtra" ng-if="itemOnly && isValid">' +
                '<div class="controls" ng-show="quantity > 0 || (paxConfig.adults + paxConfig.children + paxConfig.infants) > 0">' +
                    '<button class="col-xs-12 btn btn-primary select-another-item" ng-click="addToCart(true)">Add and select another <span class="add-more-items-text">item</span><span class="add-more-items-text-change"></span> <span class="glyphicon glyphicon-plus"></span></button>' +
                '</div>' +
            '</div>' +

            '<div ng-hide="editingExtra" ng-if="isValid">' +
                '<div class="controls" ng-show="quantity > 0 || (paxConfig.adults + paxConfig.children + paxConfig.infants) > 0">' +
                    '<button class="col-xs-12 btn btn-primary" ng-click="addToCart()">Add to Booking <span class="glyphicon glyphicon-plus"></span></button>' +
                '</div>' +
            '</div>' +

            '<div ng-show="editingExtra">' +
                '<div class="controls btn-group btn-group-justified">' +
                    '<div class="btn-group" role="group">' +
                        '<button ng-click="removeExtra()" class="col-xs-6 btn btn-danger">Remove Extra <span class="glyphicon glyphicon-remove"></span></button>' +
                    '</div>' +
                    '<div class="btn-group" role="group">' +
                        '<button ng-click="updateExtra()" class="col-xs-6 btn btn-primary">Update <span class="glyphicon glyphicon-ok"></span></button>' +
                    '</div>' +
                '</div>' +
            '</div>' +


        '</div>',
        link: function(scope, element, attrs){

        }
    }
});
